import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { uploadVideo } from "../services/upload";
import { CreatePost } from "../types";

export default function useCreatePost(
  options: UseMutationOptions<
    void,
    Error,
    CreatePost & { onProgress?: (p: number) => void },
    unknown
  >,
) {
  return useMutation({
    mutationFn: async (vars: CreatePost & { onProgress?: (p: number) => void }) => {
      const { onProgress, ...data } = vars;
      await uploadVideo(data, onProgress);
    },
    ...options,
  });
}
